import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AppTokenHandler {
    public access_token_key = 'access_token';
    public azure_token_key = 'azure_token';
    loginUserInfo: UserInfo;
    constructor(private cookieService: CookieService) {

    }
    // Store token securely in a cookie
    setAccessTokenInCookie(token: string): void {
        this.cookieService.set(this.access_token_key, token, {
            expires: 1,  // Expires in 1 day
            secure: true, // Ensures cookie is only sent over HTTPS
            sameSite: 'Strict', // Prevents CSRF attacks
            path: '/' // Available throughout the application
        });
    }
    setAzureTokenInCookie(token: string): void {
        this.cookieService.set(this.azure_token_key, token, {
            expires: 1,  // Expires in 1 day
            secure: true, // Ensures cookie is only sent over HTTPS
            sameSite: 'Strict', // Prevents CSRF attacks
            path: '/' // Available throughout the application
        });
    }

    // Retrieve token from cookie
    getAccessTokenFromCookie(): string {
        return this.cookieService.get(this.access_token_key);
    }
    getAzureTokenFromCookie(): string {
        return this.cookieService.get(this.azure_token_key);
    }

    // Delete token (on logout or other events)
    removeTokenCookie(): void {
        this.cookieService.delete(this.access_token_key, '/');
        this.cookieService.delete(this.azure_token_key, '/');
    }
    getSessionToken() {
        if (this.getAccessTokenFromCookie()) {
            return this.getAccessTokenFromCookie()
        }
        return "";
    }
    setSessionToken(loginData) {
        this.setAccessTokenInCookie(loginData.access_token);
        loginData.access_token = "";
        sessionStorage.setItem('RBUserInfo', JSON.stringify(loginData.UserInfo));
    }
    clearSessionToken() {
        sessionStorage.removeItem('RBUserInfo');
        this.removeTokenCookie();
    }
    getLoginUserInfo(): UserInfo {
        this.loginUserInfo = JSON.parse(sessionStorage.getItem('RBUserInfo'));
        return this.loginUserInfo;
    }
    IsInRole(role: string): boolean {
        let validRole: boolean = false;
        let loginInfo: UserInfo = this.getLoginUserInfo();
        let roles: string[] = loginInfo.Roles.split(',');
        let userrole: string[] = role.split(',');
        userrole.forEach(element => {
            debugger
            if (roles.find(x => x.indexOf(element) >= 0)) {
                validRole = true;
            }
        });

        return validRole;
    }
    setRequestType(RequestType: string) {
        sessionStorage.removeItem('RequestType');
        sessionStorage.setItem('RequestType', RequestType);
    }
    getRequestType() {
        let RequestType: string = "";
        if (sessionStorage.getItem('RequestType') != null)
            RequestType = sessionStorage.getItem('RequestType');;
        return RequestType;
    }
}

export class UserInfo {
    UserId: string;
    EmpGPN: string;
    EmpEmail: string;
    EmpName: string;
    Roles: string;
    ExpiresUtc: Date;
    DigiPitchID: number;
}

@Injectable()
export class HTTPStatus {
    private requestInFlight$: BehaviorSubject<boolean>;
    constructor() {
        this.requestInFlight$ = new BehaviorSubject(false);
    }

    setHttpStatus(inFlight: boolean) {
        this.requestInFlight$.next(inFlight);
    }

    getHttpStatus(): Observable<boolean> {
        return this.requestInFlight$.asObservable();
    }
}
